export default __webpack_public_path__ + "static/midfi-6cc5a3cef0663dd9c636feff6ae7ceb0.png";